// @flow
// $FlowFixMe
import { useQuery } from '@apollo/client';
import { get } from 'lodash';
// $FlowFixMe
import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { type PropType } from '../../dataTypesAndUtils';

import { calculatePercent } from '../dataTypesAndUtils';

import { insightsSuspiciousNewDomainsQuery } from './dataTypesAndUtils';
import MostCommonTopLevelDomains from './MostCommonTopLevelDomains';
import RecentlyRegisteredDomains from './RecentlyRegisteredDomains';

import { DaysBackContext } from 'screens/App';
// $FlowFixMe
import { setInsightsDateRangeFromDuration } from 'utils/dateRangeFromDuration';

export default function SuspiciousNewDomainsOverview({ detectionCount, detectionError, detectionLoading }: PropType) {
  const { currentInterval } = useContext(DaysBackContext);
  const { t } = useTranslation('email');

  const { data, error, loading } = useQuery(insightsSuspiciousNewDomainsQuery, {
    variables: setInsightsDateRangeFromDuration(currentInterval),
  });
  const domainsCurrent = get(data, 'suspiciousNewDomains.data.timeline.current', [{}]);
  const domainsPrevious = get(data, 'suspiciousNewDomains.data.timeline.previous', [{}]);
  const totalDomains = get(data, 'suspiciousNewDomains.data.totals', { current: 0, previous: 0 });
  const commonDomains = get(data, 'suspiciousNewDomains.data.breakdown.current', {});

  return (
    <>
      <Helmet title={`${t('newDomains')} :: ${t('common:email')} - ${t('const:names:area1security')}`} />

      <>
        <RecentlyRegisteredDomains
          data={{
            lineGraph: {
              current: domainsCurrent,
              previous: domainsPrevious,
            },
            ringChart: calculatePercent(totalDomains.current, detectionCount),
            sectionOverview: {
              current: totalDomains.current,
              previous: totalDomains.previous,
            },
          }}
          error={error || detectionError}
          loading={loading || detectionLoading}
        />
        <MostCommonTopLevelDomains data={commonDomains} error={error} loading={loading} />
      </>
    </>
  );
}
